import { Routes, Route } from "react-router-dom";

// Páginas top-level
import Home from "../pages/Home";
import Analyze from "../pages/Analyze";
import BrowseV2 from "../pages/BrowseV2";
import Download from "../pages/Download";


//Transicion de paginas
import { AnimatePresence } from "framer-motion";
import PageTransition from "../shared/components/PageTransition";

//Download Data
import Data from "../pages/Download/Data";

import AnalyzeResultsCitations from "../pages/results/AnalyzeResultsCitations";
import TrainingVideos from "../pages/TrainingVideos/TrainingVideos";



const DownloadProtocols = () => <div>Download Protocols (todo)</div>;
const DownloadAlgorithms = () => <div>Download Algorithms (todo)</div>;

export default function AppRoutes() {
    return (
        <AnimatePresence>
            <Routes>
                <Route
                    path="/"
                    element={
                        <PageTransition>
                            <Home />
                        </PageTransition>}
                />

                {/* ANALYZE */}
                <Route
                    path="/analyze"
                    element={
                        <PageTransition>
                            <Analyze />
                        </PageTransition>
                    } />


                {/* BROWSE */}
                <Route path="/browse">
                    <Route
                        index
                        element={
                            <PageTransition>
                                <BrowseV2 />
                            </PageTransition>
                        } />
                </Route>

                {/* DOWNLOAD (general) */}
                <Route path="/download">
                    <Route
                        index
                        element={
                            <PageTransition>
                                <Download />
                            </PageTransition>
                        } />
                    <Route
                        path="data"
                        element={
                            <PageTransition>
                                <Data />
                            </PageTransition>
                        } />
                    <Route
                        path="protocols"
                        element={
                            <PageTransition>
                                <DownloadProtocols />
                            </PageTransition>
                        } />
                    <Route
                        path="algorithms"
                        element={
                            <PageTransition>
                                <DownloadAlgorithms />
                            </PageTransition>
                        } />


                </Route>
                {/* ANALYZE */}
                <Route
                    path="/trainingVideos"
                    element={
                        <PageTransition>
                            <TrainingVideos />
                        </PageTransition>
                    } />

            </Routes>
        </AnimatePresence>
    );
}